module.exports = __webpack_public_path__ + "imgs/seeds.307071619d9a10f947841461f23f903c.jpg";